// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"358fe362","275":"dbfe2744","388":"ba8b66ff","641":"e34c9b6d","906":"20e4cbd9","920":"ab942830"}[chunkId] + ".chunk.js";
};